/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ period: NonNullable<unknown> }} Wrapped_Period_Not_Ready_BodyInputs */

const en_us2_wrapped_period_not_ready_body = /** @type {(inputs: Wrapped_Period_Not_Ready_BodyInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Once a month with a workout ends, its numbers become cards here.`);
	return /** @type {LocalizedString} */ (`Once a year with a workout ends, its numbers become cards here.`)
	
};

const pt_br2_wrapped_period_not_ready_body = /** @type {(inputs: Wrapped_Period_Not_Ready_BodyInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Quando um mês com treino terminar, os números dele viram cartões aqui.`);
	return /** @type {LocalizedString} */ (`Quando um ano com treino terminar, os números dele viram cartões aqui.`)
	
};

const es_419_wrapped_period_not_ready_body = /** @type {(inputs: Wrapped_Period_Not_Ready_BodyInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Cuando termine un mes con entrenamiento, sus números se convierten en tarjetas aquí.`);
	return /** @type {LocalizedString} */ (`Cuando termine un año con entrenamiento, sus números se convierten en tarjetas aquí.`)
	
};

const pt_pt2_wrapped_period_not_ready_body = /** @type {(inputs: Wrapped_Period_Not_Ready_BodyInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Quando um mês com treino terminar, os números dele passam a ser cartões aqui.`);
	return /** @type {LocalizedString} */ (`Quando um ano com treino terminar, os números dele passam a ser cartões aqui.`)
	
};

const fr_fr2_wrapped_period_not_ready_body = /** @type {(inputs: Wrapped_Period_Not_Ready_BodyInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Dès qu'un mois avec une séance se termine, ses chiffres deviennent des cartes ici.`);
	return /** @type {LocalizedString} */ (`Dès qu'une année avec une séance se termine, ses chiffres deviennent des cartes ici.`)
	
};

const de_de2_wrapped_period_not_ready_body = /** @type {(inputs: Wrapped_Period_Not_Ready_BodyInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Sobald ein Monat mit Training endet, werden seine Zahlen hier zu Karten.`);
	return /** @type {LocalizedString} */ (`Sobald ein Jahr mit Training endet, werden seine Zahlen hier zu Karten.`)
	
};

const it_it2_wrapped_period_not_ready_body = /** @type {(inputs: Wrapped_Period_Not_Ready_BodyInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`Quando un mese con un allenamento finisce, i suoi numeri diventano card qui.`);
	return /** @type {LocalizedString} */ (`Quando un anno con un allenamento finisce, i suoi numeri diventano card qui.`)
	
};

/**
* | period | output |
* | --- | --- |
* | "month" | "Once a month with a workout ends, its numbers become cards here." |
* | * | "Once a year with a workout ends, its numbers become cards here." |
*
* @param {Wrapped_Period_Not_Ready_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_period_not_ready_body = /** @type {((inputs: Wrapped_Period_Not_Ready_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Period_Not_Ready_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_period_not_ready_body(inputs)
	if (locale === "es-419") return es_419_wrapped_period_not_ready_body(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_period_not_ready_body(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_period_not_ready_body(inputs)
	if (locale === "de-DE") return de_de2_wrapped_period_not_ready_body(inputs)
	if (locale === "it-IT") return it_it2_wrapped_period_not_ready_body(inputs)
	return en_us2_wrapped_period_not_ready_body(inputs)
});
export { wrapped_period_not_ready_body as "wrapped-period.not_ready_body" }